export const categories = [
  {
    slug: 'xinggan-chuanda',
    name: '性感穿搭技巧',
    description: '掌握性感穿搭的精髓，从日常到约会，展现你的迷人曲线与独特风格',
    icon: 'ri-t-shirt-line',
  },
  {
    slug: 'qizhi-tisheng',
    name: '气质提升方法',
    description: '从内到外培养优雅气质，让自信成为你最动人的魅力武器',
    icon: 'ri-heart-pulse-line',
  },
  {
    slug: 'xinggan-zhuangrong',
    name: '性感妆容教程',
    description: '专业化妆技巧全解析，打造令人心动的高级性感妆容',
    icon: 'ri-palette-line',
  },
  {
    slug: 'zixin-fengge',
    name: '自信女性风格',
    description: '找到属于你的独特风格，活出最闪耀的自己',
    icon: 'ri-star-line',
  },
  {
    slug: 'shishang-zaoxing',
    name: '时尚性感造型',
    description: '紧随潮流趋势，打造让人过目不忘的时尚性感造型',
    icon: 'ri-sparkling-line',
  },
];